import React from "react";
import CreateRanking from "./CreateRanking/CreateRanking";

const CreateRankingPage = () => {
  return <CreateRanking />;
};

export default CreateRankingPage;
